"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Select;

var _Select = require("@adobe/react-spectrum-workflow/dist/Select");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Select(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Select.A4uSelect, null));
}